let tag;

const getTagTracker = () => {
  if (!tag) {
    // eslint-disable-next-line no-undef
    tag = new ATInternet.Tracker.Tag({
      secure: true
    });
  }

  return tag;
};
/**
 *
 * @param {*} siteInfo
 * @param {*} customVars
 */


const trackPage = (siteInfo, customVars) => {
  const tagTracker = getTagTracker();
  tagTracker.page.set(siteInfo);
  tagTracker.customVars.set(customVars);
  tagTracker.dispatch();
};

export default trackPage;